import { IntakeAction, IntakeActionType } from '../actions/IntakeActions';
import { Intake } from '../types';

const intakeReducer = (state: Array<Intake> = [], action: IntakeAction) => {
    switch (action.type) {
        case IntakeActionType.GET_ALL_INTAKES:
        case IntakeActionType.GET_ALL_ADMIN_INTAKES:
            return action.payload;
        case IntakeActionType.CREATE_INTAKES:
            return [...state, action.payload];
        case IntakeActionType.GET_INTAKE:
        case IntakeActionType.DELETE_INTAKES:
        case IntakeActionType.MERGE_INTAKES:
        case IntakeActionType.UPDATE_INTAKES:
            return state.map((intake: Intake) => {
                const newTG = action.payload as Intake;
                if (intake._id === newTG._id) {
                    return newTG;
                } else {
                    return intake;
                }
            });
        default:
            return state;
    }
};

export default intakeReducer;
